@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../style.module.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../../constants/spacing.module.less';

@fontSize: 13px;

.input-wrapper {
  font-size: @fontSize;
  padding-bottom: 10px;
}

.number-input {
  .input-border-base-style();
}

.input-label {
  font-weight: 500;
  padding-bottom: 5px;
}

.slim-input {
  width: 80px;

  &.cost {
    Input {
      .input-border-base-style();
    }
  }
}

.edit-notes {
  width: 100%;
  height: 100px;
  .input-border-base-style();
}

.popover-notes {
  width: 100%;
  height: 32px;
  .input-border-base-style();
}

.dual-field {
  flex-wrap: nowrap;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  gap: @space-64;
}

.balanced,
.name-sku-wrap {
  > div {
    width: 50%;
  }
}

.name-sku-wrap {
  margin-bottom: @space-8;
  flex: 1;
}

.name-sku-container {
  margin-bottom: @space-8;
}

.product-thumbnail {
  border-radius: @space-4;
  object-fit: cover;
  flex-shrink: 0;
}

.no-image-placeholder {
  display: block;
  width: @space-48;
  height: @space-48;
  background-color: var(--grey-300);
  border-radius: @space-4;
  flex-shrink: 0;
}

.name-or-sku {
  color: @product-page--inventory-name-sku--text-color;
  .truncate();
}

.date-picker {
  width: 100%;
  height: 32px;
  input,
  button {
    height: 32px;
  }
  input {
    border: 1px solid var(--grey-500);
  }
}
